import { Helper } from '@/services/helper/helper'

/**
 * Abstract class providing different logging functions.
 * @abstract
 */
export default class Logger {
  /**
   * default styling for console messages
   * @type {string}
   */
  static DEFAULT_STYLE = 'padding: 5px; color: black; background-color: yellow'

  /**
   * url parameters
   * @type {URLSearchParams}
   */
  static URL_PARAMS = new URLSearchParams(window.location.search)

  /**
   *
   * Logs messages to the console if the current stage is not a live stage or a given url param exists.
   * Messages are printed with a default style. If you wish to remove the styling use style: ''
   *
   * @see Logger.DEFAULT_STYLE
   *
   * @param msg
   * @param urlParam
   * @param style
   */
  static log (msg, { urlParam, style }) {
    if (Helper.isLiveStage() && Logger.URL_PARAMS.get(urlParam) === null) {
      return
    }

    console.log(msg, style ?? Logger.DEFAULT_STYLE)
  }
}
